import React from 'react';
import { Link } from 'react-router-dom';

const Layout = ({ children }) => {
  return (
    // Dark mode body background and light text
    <div className="min-h-screen flex flex-col bg-gray-950 text-gray-100">
      
      {/* Top Utility Bar (Minimalist) */}
      <header className="bg-gray-900 border-b border-gray-800 px-6 py-2 text-sm font-medium text-center">
        <div className="flex justify-center space-x-6">
          
          {/* Utility/Info Links */}
          <Link to="/about" className="text-gray-400 hover:text-teal-400 transition">
            About This Project
          </Link>
          <span className="text-gray-700">|</span>
          <Link to="/contact" className="text-gray-400 hover:text-teal-400 transition">
            Feedback & Contact
          </Link>
          <span className="text-gray-700">|</span>
          <Link to="/login" className="text-gray-400 hover:text-teal-400 transition">
            Dev Access
          </Link>
        </div>
      </header>

      {/* Page Content */}
      <main className="flex-grow container mx-auto px-4 py-12">
        {children}
      </main>

      {/* Footer: Focus on Tech/IP */}
      <footer className="bg-gray-900 border-t border-teal-500 text-center text-sm text-gray-400 py-6">
        <div className="mb-2">
          &copy; {new Date().getFullYear()} DecentralizedDev MVP. All Rights Reserved.
        </div>
        <div className="mt-1 text-xs text-indigo-400 font-semibold">
          Disclaimer: Data is for informational purposes only. Not financial advice.
        </div>
      </footer>
    </div>
  );
};

export default Layout;
